import React from 'react';
import { motion } from 'framer-motion';
import SidePanelFrame from './SidePanelFrame';

export default function RoomBackground() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* Back wall — single soft pastel wash (warm cream → butter; avoids grey/tan mid-tones) */}
      <div className="absolute inset-0 bg-[radial-gradient(125%_100%_at_50%_12%,_#FFFCF8_0%,_#FFF6E8_38%,_#FFEFD0_72%,_#FFE8BC_100%)]" />

      {/* Rear mural-like glows (far distance) */}
      <motion.div
        className="absolute top-[-120px] left-[10%] h-72 w-72 rounded-full bg-amber-100/50 blur-3xl"
        animate={{ y: [0, -10, 0] }}
        transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute top-[18%] right-[8%] h-80 w-80 rounded-full bg-yellow-100/45 blur-3xl"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Side framing gives enclosure */}
      <SidePanelFrame side="left" />
      <SidePanelFrame side="right" />

      {/* Midground floating framed accents */}
      <div className="absolute left-[8%] top-[28%] h-28 w-20 rotate-[-7deg] rounded-2xl border border-white/60 bg-white/35 shadow-[0_12px_32px_rgba(251,191,36,0.12)] backdrop-blur-sm" />
      <div className="absolute right-[11%] top-[35%] h-24 w-16 rotate-[8deg] rounded-2xl border border-white/60 bg-white/30 shadow-[0_10px_28px_rgba(251,191,36,0.1)] backdrop-blur-sm" />
    </div>
  );
}
